import { z } from 'zod';
import { UserSchema } from './user.types.js';

export const FeatureFlagScopeSchema = z.enum(['global', 'account']);
export type FeatureFlagScope = z.infer<typeof FeatureFlagScopeSchema>;

const FeatureFlagBaseSchema = z.object({
  key: z.string(),
  label: z.string(),
  description: z.string(),
  enabled: z.boolean(),
  defaultValue: z.boolean(),
});

export const FeatureFlagSchema = FeatureFlagBaseSchema.extend({
  scope: FeatureFlagScopeSchema,
}).meta({ id: 'FeatureFlag' });
export type FeatureFlag = z.infer<typeof FeatureFlagSchema>;

export const AccountFeatureFlagSchema = FeatureFlagBaseSchema.extend({
  hasOverride: z.boolean(),
});
export type AccountFeatureFlag = z.infer<typeof AccountFeatureFlagSchema>;

export const FlagUserOverrideSchema = z
  .object({
    userId: z.string(),
    flagKey: z.string(),
    enabled: z.boolean(),
    user: UserSchema,
  })
  .meta({ id: 'FlagUserOverride' });
export type FlagUserOverride = z.infer<typeof FlagUserOverrideSchema>;
